import { render, staticRenderFns } from "./member-counter-card.vue?vue&type=template&id=0f8ed360&scoped=true"
import script from "./member-counter-card.vue?vue&type=script&lang=js"
export * from "./member-counter-card.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f8ed360",
  null
  
)

export default component.exports